import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const statusConfig = {
  pending: {
    label: "Oczekujące",
    classes: "border-[hsl(38_60%_28%)] bg-[hsl(38_30%_14%)] text-[hsl(38_92%_70%)]",
  },
  accepted: {
    label: "Zaakceptowane",
    classes: "border-[hsl(152_45%_26%)] bg-[hsl(152_30%_12%)] text-[hsl(152_62%_70%)]",
  },
  rejected: {
    label: "Odrzucone",
    classes: "border-[hsl(0_55%_26%)] bg-[hsl(0_30%_12%)] text-[hsl(0_78%_72%)]",
  },
  "needs-info": {
    label: "Wymaga informacji",
    classes: "border-[hsl(199_55%_26%)] bg-[hsl(199_30%_12%)] text-[hsl(199_92%_72%)]",
  },
  not_started: {
    label: "Nie rozpoczęto",
    classes: "border-border bg-secondary text-secondary-foreground",
  },
  success: {
    label: "Sukces",
    classes: "border-[hsl(152_45%_26%)] bg-[hsl(152_30%_12%)] text-[hsl(152_62%_70%)]",
  },
  failed: {
    label: "Błąd",
    classes: "border-[hsl(0_55%_26%)] bg-[hsl(0_30%_12%)] text-[hsl(0_78%_72%)]",
  },
  awaiting_bot_setup: {
    label: "Czeka na bota",
    classes: "border-primary/30 bg-primary/10 text-primary",
  },
};

export const StatusPill = ({ status, className, "data-testid": dataTestId }) => {
  const config = statusConfig[status] || {
    label: status || "Nieznany",
    classes: "border-border bg-secondary text-secondary-foreground",
  };

  return (
    <Badge
      data-testid={dataTestId}
      className={cn("rounded-full border px-3 py-1 text-xs font-medium tracking-wide", config.classes, className)}
    >
      {config.label}
    </Badge>
  );
};
